import IconDropDown from "app/components/Icon/components/IconDropDown/IconDropDown";
import { useEffect, useState } from "react";
import { FormattedMessage, IntlShape } from "react-intl";

type Props = {
  intl: IntlShape;
  currency: string;
  handleChange: (id: string, value: string) => void;
  currencyValidated: boolean;
  currencyValidationError: boolean;
  setCurrencyValidationError: (currencyValidationError: boolean) => void;
  listOfCurrencies: any;
  errors: { [key: string]: string };
};

const Currency = ({
  intl,
  currency,
  handleChange,
  currencyValidationError,
  setCurrencyValidationError,
  currencyValidated,
  listOfCurrencies,
  errors,
}: Props) => {
  const [errorCurrency, setErrorCurrency] = useState<string>("");
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);

  const validateCurrency = (id: string, value: string) => {
    if (value === "") {
      setErrorCurrency(
        intl.formatMessage({
          id: "Required",
        })
      );
    } else {
      setErrorCurrency("");
      setCurrencyValidationError(false);
    }
  };

  const toggleCurrencyDropdown = () => {
    setShowCurrencyDropdown(!showCurrencyDropdown);
  };

  const closeCurrencyDropdown = () => {
    setShowCurrencyDropdown(false);
  };

  const displaySelectedCurrency = (currency: string) => {
    // using the currency code to display the currency in the format of "USD ($)"
    const currencyObject = listOfCurrencies.find(
      currencyObject => currencyObject.id === currency
    );
    if (currencyObject) {
      return `${currencyObject.code} (${currencyObject.format})`;
    }
    return currencyObject;
  };

  const currencySelected = (currency: string, id: string) => {
    handleChange("currency", id);
  };

  useEffect(() => {
    if (currencyValidationError) {
      validateCurrency("currency", "");
    }
    if (currency !== "") {
      validateCurrency("currency", currency);
    }
  }, [currencyValidationError, currency]);

  return (
    <div className="form-details__row">
      <div>
        <FormattedMessage tagName="label" id="settings-currency" />
        <span className="required">*</span>
      </div>
      <div className="form-details__row--input form-details__row--input--currency">
        <div
          className={`currency-dropdown ${errorCurrency ? "errors" : ""}`}
          onClick={() => toggleCurrencyDropdown()}
        >
          {currency === ""
            ? intl.formatMessage({
                id: "settings-select-currency",
              })
            : displaySelectedCurrency(currency)}
          <span className="currency-dropdown--arrow">
            <IconDropDown />
          </span>
        </div>
        <div
          className={`currency-dropdown-list ${
            showCurrencyDropdown ? "show" : "hide"
          }`}
          onMouseUp={() => closeCurrencyDropdown()}
          onMouseLeave={() => closeCurrencyDropdown()}
        >
          {listOfCurrencies.map((currency, index) => (
            <div
              className="currency-dropdown-list--item"
              key={index}
              onClick={() => {
                closeCurrencyDropdown();
                currencySelected("currency", currency.id);
              }}
            >
              <input
                type="radio"
                value={currency.id}
                checked={currency.id === currency}
              />
              <span key={index} id={currency.id}>
                {currency.code}
                &nbsp;({currency.format})
              </span>
            </div>
          ))}
        </div>
      </div>
      <div>
        {errorCurrency && (
          <span className="error-message">{errorCurrency}</span>
        )}
      </div>
    </div>
  );
};

export default Currency;
